export default __webpack_public_path__ + "static/media/logoLogin.6a07d887.svg";